import { getDefaultExportFromCjs as w } from "../../../_virtual/_commonjsHelpers.mjs";
import { exports as l, __module as A } from "../../../_virtual/index2.mjs";
import T from "../../sister/src/sister.mjs";
import "./YouTubePlayer.mjs";
import "./loadYouTubeIframeApi.mjs";
import { exports as Y } from "../../../_virtual/YouTubePlayer.mjs";
import { exports as h } from "../../../_virtual/loadYouTubeIframeApi.mjs";
(function(p, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var d = T, y = o(d), c = Y, f = o(c), _ = h, m = o(_);
  function o(e) {
    return e && e.__esModule ? e : { default: e };
  }
  let a;
  t.default = (e, u = {}, v = !1) => {
    const r = (0, y.default)();
    if (a || (a = (0, m.default)(r)), u.events)
      throw new Error("Event handlers cannot be overwritten.");
    if (typeof e == "string" && !document.getElementById(e))
      throw new Error('Element "' + e + '" does not exist.');
    u.events = f.default.proxyEvents(r);
    const P = new Promise((i) => {
      typeof e == "object" && e.playVideo instanceof Function ? i(e) : a.then((n) => {
        const x = new n.Player(e, u);
        return r.on("ready", () => {
          i(x);
        }), null;
      });
    }), s = f.default.promisifyPlayer(P, v);
    return s.on = r.on, s.off = r.off, s;
  }, p.exports = t.default;
})(A, l);
const q = /* @__PURE__ */ w(l);
export {
  q as default
};
//# sourceMappingURL=index.mjs.map
